import Vue from 'vue';
import Component from 'vue-class-component';
import { AUTH_EVENTS, USER_TYPE } from '@/auth/values/auth.values';

@Component({
  name: 'ed-register-profile'
})
export default class EdRegisterProfileComponent extends Vue {
  
  goToCreateTeacher() {
    this.$edEventBus.$emit(AUTH_EVENTS.ON_CHANGE_REGISTER_STEP, {step: 2, userType: USER_TYPE.TEACHER})
  }

  goToCreateStudent() {
    this.$edEventBus.$emit(AUTH_EVENTS.ON_CHANGE_REGISTER_STEP, {step: 2, userType: USER_TYPE.STUDENT})
  }
}